import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "backdrop", "main"]
  static values = {
    open: { type: Boolean, default: true }
  }

  connect() {
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)

    if (window.innerWidth < 1024) {
      this.openValue = false
    } else {
      const stored = localStorage.getItem("sidebar_open")
      this.openValue = stored !== null ? stored === "true" : true
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    if (window.innerWidth < 1024 && this.openValue) {
      this.openValue = false
    }
  }

  toggle() {
    this.openValue = !this.openValue
    if (window.innerWidth >= 1024) {
      localStorage.setItem("sidebar_open", this.openValue.toString())
    }
  }

  close() {
    this.openValue = false
    if (window.innerWidth >= 1024) {
      localStorage.setItem("sidebar_open", "false")
    }
  }

  open() {
    this.openValue = true
    if (window.innerWidth >= 1024) {
      localStorage.setItem("sidebar_open", "true")
    }
  }

  openValueChanged() {
    this.element.dataset.sidebarOpen = this.openValue ? "true" : "false"
  }
}
